export const PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT = 'PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT';
export const PARTNER_DASHBOARD_SERVICE_PRICING_PROOF = 'PARTNER_DASHBOARD_SERVICE_PRICING_PROOF';
export const PARTNER_MARKETING_OPT_IN = 'PARTNER_MARKETING_OPT_IN';
export const PARTNER_DASHBOARD_TIME_SLOT_CAMPAIGNS = 'PARTNER_DASHBOARD_TIME_SLOT_CAMPAIGNS';
export const SCHEDULE_CALENDAR_V2 = 'SCHEDULE_CALENDAR_V2';
export const PARTNERS_SCHEDULE_FILTERS_V2 = 'PARTNERS_SCHEDULE_FILTERS_V2';

export const OPTIMIZELY_FEATURE_FLAGS_KEYS = {
  [PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT]: 'partner_dashboard_trial_program_mode_edit',
  [PARTNER_DASHBOARD_SERVICE_PRICING_PROOF]: 'partner_dashboard_service_pricing_proof',
  [PARTNER_MARKETING_OPT_IN]: 'partner_marketing_opt_in',
  [PARTNER_DASHBOARD_TIME_SLOT_CAMPAIGNS]: 'partner_dashboard_time_slot_campaigns',
  [SCHEDULE_CALENDAR_V2]: 'partners_schedule_calendar_v2',
  [PARTNERS_SCHEDULE_FILTERS_V2]: 'partners_schedule_filters_v2',
};
